import { useLocalStorageValue } from "@react-hookz/web";
import { createContext, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useError } from "../hooks/useError";

import { Api } from "../utils/Api";
import { User } from "../utils/typings";

interface Context {
  isLoggedIn: boolean;
  getUser: () => Promise<void>;
  logout: () => void;
  user?: User | null;
  isSubmitting: boolean;
}

export const AuthContext = createContext({} as Context);

export const AuthProvider = ({ children }: any) => {
  const navigate = useNavigate();
  const { handleError } = useError();

  const [isLoggedIn, setIsLoggedIn] = useLocalStorageValue("isLoggedIn", false);
  const [user, setUser] = useState<User>();
  const [token, setToken] = useLocalStorageValue<string>("token", "");

  useEffect(() => {
    if (!user) getUser();
  }, []);

  const getUser = useCallback(async () => {
    const { data } = await Api.getUser();
    setUser(data);
  }, [navigate, setIsLoggedIn, setToken]);

  const logout = useCallback(async () => {
    try {
      await Api.logout();
      setIsLoggedIn(false);
      localStorage.removeItem("user");
      navigate("/portal-login");
    } catch (error) {
      handleError(error);
    }
  }, [handleError, navigate, setIsLoggedIn, setToken, setUser]);

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoggedIn,
        getUser,
        logout,
        isSubmitting: false,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
